import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/lib/api";

/** Retrying a 4xx is pointless: the request itself is the problem. */
function retryOnlyServerErrors(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: retryOnlyServerErrors,
        // The window regaining focus is not a good enough reason to refetch
        // an admin table; an explicit action or an invalidation is.
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
